import { createElement } from 'react';
import { Dropdown as OriginalDropdown, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { withSingleChild } from '../../utils/hoc';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const Dropdown = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const { open, ...rest } = props;
    const innerProps = {};
    if (rest.__designmode === 'design') {
        // 低代码编辑态中强制显示，将控制权交给引擎侧
        innerProps.open = true;
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(OriginalDropdown, { open: open !== '-' ? open : undefined, ...rest, ...innerProps })));
};
export default withSingleChild(Dropdown, ['children', 'overlay']);
